import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import MainLayout from 'src/layouts/main';
import SimpleLayout from 'src/layouts/simple';
import CompactLayout from 'src/layouts/compact';
import CategoryDetailsHomePage from 'src/pages/category/details';
import CategoryListHomePage from 'src/pages/category/list';

// ----------------------------------------------------------------------

export const HomePage = lazy(() => import('src/pages/home'));
const Page500 = lazy(() => import('src/pages/500'));
const Page403 = lazy(() => import('src/pages/403'));
const Page404 = lazy(() => import('src/pages/404'));
const FaqsPage = lazy(() => import('src/pages/faqs'));
const AboutPage = lazy(() => import('src/pages/about-us'));
const JoinPage = lazy(() => import('src/pages/join-us'));
const DownloadsPage = lazy(() => import('src/pages/downloads'));
const Services = lazy(() => import('src/pages/services'));
const Portfolio = lazy(() => import('src/pages/portfolio'));
const ContactPage = lazy(() => import('src/pages/contact-us'));
const PricingPage = lazy(() => import('src/pages/pricing'));
const PaymentPage = lazy(() => import('src/pages/payment'));
const CheckoutPage = lazy(() => import('src/pages/qib/CheckoutPage'));
const QibResponsePage = lazy(() => import('src/pages/payment/qib-response'));
const PaymentSuccessPage = lazy(() => import('src/pages/payment/PaymentSuccess'));
const OrderSuccessPage = lazy(() => import('src/pages/payment/OrderSuccess'));
const OrderFailedPage = lazy(() => import('src/pages/payment/OrderFailed'));
const SubscriptionSuccessPage = lazy(() => import('src/pages/payment/SubscriptionSuccess'));
const SubscriptionFailedPage = lazy(() => import('src/pages/payment/SubscriptionFailed'));
const ComingSoonPage = lazy(() => import('src/pages/coming-soon'));
const MaintenancePage = lazy(() => import('src/pages/maintenance'));
// PRODUCT
const ProductListPage = lazy(() => import('src/pages/product/list'));
const ProductDetailsPage = lazy(() => import('src/pages/product/details'));
const ProductCheckoutPage = lazy(() => import('src/pages/product/checkout'));
// SUBSCRIPTION
const SubscriptionPage = lazy(() => import('src/pages/subscription'));
// BLOG
const PostListPage = lazy(() => import('src/pages/post/list'));
const PostDetailsPage = lazy(() => import('src/pages/post/details'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    element: (
      <MainLayout>
        <Outlet />
      </MainLayout>
    ),
    children: [
      { path: 'main', element: <HomePage /> },
      { path: 'about-us', element: <AboutPage /> },
      { path: 'join-us', element: <JoinPage /> },
      { path: 'downloads', element: <DownloadsPage /> },
      { path: 'contact-us', element: <ContactPage /> },
      { path: 'services', element: <Services /> },
      { path: 'portfolio', element: <Portfolio /> },
      { path: 'faqs', element: <FaqsPage /> },
      {
        path: 'product',
        children: [
          { element: <ProductListPage />, index: true },
          { path: 'list', element: <ProductListPage /> },
          { path: ':id', element: <ProductDetailsPage /> },
          { path: 'checkout', element: <ProductCheckoutPage /> },
        ],
      },
      { path: 'subscription', element: <SubscriptionPage /> },
      {
        path: 'post',
        children: [
          { element: <PostListPage />, index: true },
          { path: 'list', element: <PostListPage /> },
          { path: ':title', element: <PostDetailsPage /> },
        ],
      },
      {
        path: 'category',
        children: [
          { element: <CategoryListHomePage />, index: true },
          { path: 'list', element: <CategoryListHomePage /> },
          { path: ':id', element: <CategoryDetailsHomePage /> },
          { path: 'checkout', element: <ProductCheckoutPage /> },
        ],
      },
    ],
  },
  {
    element: (
      <SimpleLayout>
        <Outlet />
      </SimpleLayout>
    ),
    children: [
      { path: 'pricing', element: <PricingPage /> },
      { path: 'payment', element: <PaymentPage /> },
      { path: 'payment/qib-response', element: <QibResponsePage /> },
      { path: 'payment/PaymentSuccess', element: <PaymentSuccessPage /> },
      { path: 'payment/OrderSuccess', element: <OrderSuccessPage /> },
      { path: 'payment/OrderFailed', element: <OrderFailedPage /> },
      { path: 'payment/SubscriptionSuccess', element: <SubscriptionSuccessPage /> },
      { path: 'payment/SubscriptionFailed', element: <SubscriptionFailedPage /> },
      { path: 'checkout', element: <CheckoutPage /> },
    ],
  },
  {
    element: (
      <CompactLayout>
        <Outlet />
      </CompactLayout>
    ),
    children: [
      { path: 'coming-soon', element: <ComingSoonPage /> },
      { path: 'maintenance', element: <MaintenancePage /> },
      { path: '500', element: <Page500 /> },
      { path: '404', element: <Page404 /> },
      { path: '403', element: <Page403 /> },
    ],
  },
];
